import { MenuIcon } from '../components/icons.jsx';
import { useMenu } from './MenuProvider.jsx';

// The header's burger menu button — the web counterpart of the app's top-left
// Menu icon (NavigationCommon HeaderLeft, shown only on the Property screen; every
// other screen has a back control in that corner, and the same holds here).
// Pressing it opens the MenuDrawer, which carries what the app's Menu screen
// offers on the web: the Help section, the development-flag toggles and Logout.
// Logout used to be a bare button in the header's top-right; it now lives inside
// this menu, as in the app.
//
// The drawer and its open state live in MenuProvider (mounted by GatedLayout),
// not here: this button appears on both the Property screen and the skeleton
// that precedes it, and a drawer owned by the button would close when one
// replaces the other. The button is icon-only, so it carries its accessible name
// itself, and it declares the dialog it pops so assistive tech knows what
// pressing it does.
export default function AppMenu() {
  const { open, openMenu } = useMenu();

  return (
    <button
      type="button"
      className="icon-button"
      aria-label="Menu"
      aria-haspopup="dialog"
      aria-expanded={open}
      onClick={openMenu}
    >
      <MenuIcon />
    </button>
  );
}
